import { ClosedMonthsBoundaries } from 'types';

export const periodIsFullOfClosedMonths = (
  closedMonthsBoundaries: ClosedMonthsBoundaries,
  startDate: Date,
  endDate: Date,
): boolean => {
  const isStartDateInClosedMonths =
    ((closedMonthsBoundaries.firstClosureDate.getFullYear() === startDate.getFullYear() &&
      closedMonthsBoundaries.firstClosureDate.getMonth() <= startDate.getMonth()) ||
      closedMonthsBoundaries.firstClosureDate.getFullYear() < startDate.getFullYear()) &&
    ((closedMonthsBoundaries.lastClosureDate.getFullYear() === startDate.getFullYear() &&
      closedMonthsBoundaries.lastClosureDate.getMonth() >= startDate.getMonth()) ||
      closedMonthsBoundaries.lastClosureDate.getFullYear() > startDate.getFullYear());

  const isEndDateInClosedMonths =
    ((closedMonthsBoundaries.firstClosureDate.getFullYear() === endDate.getFullYear() &&
      closedMonthsBoundaries.firstClosureDate.getMonth() <= endDate.getMonth()) ||
      closedMonthsBoundaries.firstClosureDate.getFullYear() < endDate.getFullYear()) &&
    ((closedMonthsBoundaries.lastClosureDate.getFullYear() === endDate.getFullYear() &&
      closedMonthsBoundaries.lastClosureDate.getMonth() >= endDate.getMonth()) ||
      closedMonthsBoundaries.lastClosureDate.getFullYear() > endDate.getFullYear());

  return isStartDateInClosedMonths && isEndDateInClosedMonths;
};
